export const STEPS_PER_SECOND_VALUE = 30
export const MINIMUM_STEP_SIZE = 1 / STEPS_PER_SECOND_VALUE
export const MIN_SLIDE_DURATION = 1